const pathAPI = `${process.env.REACT_APP_SERVICE_PATH_OSP}/api/common`;

export const apiCategory = {
	getCategory: `${pathAPI}/category`,
};
